import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import type { SchemaQuotaAdd } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

const ERROR_CREATE_QUOTA = 'Failed to create quota. Please try again.'

export const useCreateQuota = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [create, result] = esApi.endpoints.createOrgQuota.useMutation()

  const createQuota = useCallback(
    async (quota: SchemaQuotaAdd) => {
      if (!orgId) {
        return false
      }

      try {
        const createdQuota = await create({
          orgId: orgId.toString(),
          schemaQuotaAdd: quota,
        }).unwrap()
        dispatch(
          createNotification({
            'create-quota-success': {
              type: 'success',
              message: 'Quota was created successfully.',
            },
          }),
        )

        return createdQuota
      } catch (error) {
        dispatch(
          createNotification({
            'create-quota-failure': {
              type: 'error',
              message: getErrorMessage(error, ERROR_CREATE_QUOTA),
            },
          }),
        )

        return false
      }
    },
    [orgId, create, dispatch],
  )

  return [createQuota, result] as const
}
